<template>
  <div class="main">
    <form action="/">
      <van-search
        v-model="searchName"
        placeholder="请输入姓名"
        :show-action="showAction"
        @search="onSearch"
        @cancel="onCancel"
        @focus="onFocus"
        @blur="onBlur"
      />
    </form>

    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadData" class="list">
      <div v-for="(item, index) in list" :key="index" class="hcc-detail-container">
        <div>
          <img :src="item.imgUrl" alt="">
        </div>

        <div class="item-grow">
          <p>
            <span>姓&#12288;&#12288;名&nbsp;</span>
            {{item.employeeName}}
          </p>
          <p>
            <span>性&#12288;&#12288;别&nbsp;</span>
            {{item.employeeSex === 1 ? '男' : '女'}}
          </p>
          <p>
            <span>年&#12288;&#12288;龄&nbsp;</span>
            {{item.age}}
          </p>
          <p>
            <span>有效日期&nbsp;</span>
            {{item.validityBeginDate}} 至 {{item.validityEndDate}}
          </p>
        </div>
      </div>
    </van-list>

    <div class="back-button action-container">
      <van-button size="large" @click="$router.go(-1)">返回</van-button>
    </div>
  </div>
</template>

<script>
import { List, Button, Toast, Search } from "vant"
import { API } from "../../../assets/js/api"
export default {
  components: {
    [List.name]: List,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Search.name]: Search
  },
  data() {
    return {
      searchName: '',
      showAction: false,
      type: null,
      licenseNumber: '',
      loading: false,
      finished: false,
      list: [],
      pageNum: 1,
      limitCount: 20,
    }
  },
  created() {
    this.licenseNumber = this.$route.query.licenseNumber;
    this.type = this.$route.params.type;
  },  
  methods: {
    loadData() {
      this.loading = true;
      let params = {
        licenseNumber: this.licenseNumber,
        pageSize: this.pageNum
      };

      if(this.searchName) {
        Object.assign(params, {
          searchKeyWord: this.searchName
        })
      }
      this.$http({
        url: API[this.type == 0 ? (this.searchName ? 'search_valid_list' : 'get_valid_list') : (this.searchName ? 'search_invalid_list' : 'get_invalid_list')],
        type: this.searchName ? 'post' : 'get',
        data: params
      }).then(res => {
        if(res.success) {

          this.pageNum++;

          let items = res.data.merchantValidHCCDetails || res.data.merchantInvalidHCCDetails || res.data.validHCCDetailsForSearchKeyWord || res.data.inValidHCCDetailsForSearchKeyWord

          if(items.length === 0) {
            this.finished = true;
          } else {
            this.finished = false;
          }

          this.list = [...this.list, ...items];
          this.loading = false;
        } else {
          this.$message(res.msg)
          this.loading = false;
        }
      }).catch(err => {
        this.loading = false;
        console.log(err);
      })
    },
    onSearch() {
      this.list = [];
      this.pageNum = 1;
      this.loadData();
    },
    onCancel() {
      this.searchName = '';
      this.showAction = false;
      this.onSearch();
    },
    onFocus() {
      this.showAction = true;
    },
    onBlur() {
      if(!this.searchName) {
        this.showAction = false;
      } else {
        this.showAction = true;
      }
    },
  } 
}
</script>

<style lang="less" scoped>
.icon-certificate {
  width: 26px;
  height: 26px;
}
.hcc-detail-container {
  display: flex;
  align-items: center;
  border-bottom: 1PX solid #ccc;
  padding: 10px 0 10px 10px;

  p {
    margin: 5px 0;
    white-space: normal;
    font-size: 14px;
    span {
      color: #888;
    }

  }

  img {
    width: 60px;
    margin-right: 10px;
  }
}
.action-container {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 11px;
  background-color: #f5f5f9;
    button {
    background-color: #118de9;
    color: #fff;
    border-radius: 5px;
  }
}
.list {
  // margin-top: 10px;
  margin-bottom: 75px;
  background-color: #fff;
}
</style>

